import { faLink, faUnlink } from '@fortawesome/pro-light-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import { Button } from '@domain-group/suit-theme'

import ButtonWithOauth from '@components/ButtonWithOAuth'

import { confirmDelete as confirmDisconnect } from '@functions/entity'

import type { UseIntegrationDataType } from '../PageContent'

interface XeroIntegrationButtonProps {
  currentUserId: number,
  integrationDataPayload: UseIntegrationDataType,
}

const XeroIntegrationButton = (props: XeroIntegrationButtonProps) => {
  const { currentUserId, integrationDataPayload } = props

  const {
    callbacks: {
      disconnectIntegration,
    },
    disconnecting,
    hasActiveSession,
    loading: loadingIntegrationData,
  } = integrationDataPayload

  const confirmDisconnectPayload = {
    callbacks: {
      deleteFn: disconnectIntegration,
    },
    strings: {
      // eslint-disable-next-line max-len
      confirmString: 'Are you sure? This will disconnect all provider accounts currently connected to this Xero organisation.',
      deleteString: 'disconnect',
      entityName: 'Xero',
      toastText: 'Disconnected',
    },
  }

  const buttonTitle = 'Xero'

  if (hasActiveSession){
    return (
      <Button
        buttonStyle="secondaryEdit"
        // @ts-expect-error TS2322
        ghost
        icon={<FontAwesomeIcon icon={faUnlink} />}
        loading={disconnecting}
        marginRight="medium"
        // @ts-expect-error TS2345
        onClick={() => confirmDisconnect(confirmDisconnectPayload)}
        size="medium"
        width="auto"
      >
        {`Disconnect from ${buttonTitle}`}
      </Button>
    )
  }

  return (
    <ButtonWithOauth
      authProviderKey="xero_oauth2"
      buttonStyle="secondaryEdit"
      icon={<FontAwesomeIcon icon={faLink} />}
      loading={loadingIntegrationData}
      //@ts-expect-error
      marginRight="medium"
      queryParams={{
        current_user_id: currentUserId,
        redirect: window.location.href,
      }}
      size="medium"
      width="auto"
    >
      {`Connect to ${buttonTitle}`}
    </ButtonWithOauth>
  )
}

export default XeroIntegrationButton
